// HTTP
export const HTTP_CLIENT_ERROR = 503;

// message sender types (kept identical to the web-plugin wire values)
export const BOT_CONV_MESSAGE_TYPE = 'bot';
export const SELF_CONV_MESSAGE_TYPE = 'self';

// cookies
export const SESSION_COOKIE_KEY = 'bc-session-id';
export const AUTH_KEY = 'bc_auth';

// The runtime addresses published apps as `<appId>_live`.
export const PUBLISHED_APP_PREFIX = 'live';

// Sessions the guest has taken part in, remembered locally so the history rail
// still works without a Cognito session (the sessions API is authorized).
export const LOCAL_SESSIONS_KEY = 'bc-local-sessions';
